import React from 'react'

import Layout from '../components/layout'

const FaqPage = () => {

  const handleClick = (e) => {
    const clickedQuestion = e.currentTarget;
    const parentNode = e.currentTarget.parentElement;
    const relatedAnswer = parentNode.querySelector('.answer');
    
    if (clickedQuestion.classList.contains('active')) {
      clickedQuestion.classList.remove('active');
      relatedAnswer.classList.remove('active');
    } else {
      clickedQuestion.classList.add('active');
      relatedAnswer.classList.add('active');
    }
  }

  return (
    <Layout>
      <div className="section section--banner section--faq">
        <div className="section__inner section__inner--faq">
          <h1>我们可为您提供哪些帮助？</h1>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                如何通过AIRVAT免税购物？
              </h3>
            </div>
            <div className="answer">
              <ul>
                <li>在英国任何一家商店购物，但无需填写店内退税单;</li>
                <li>在购物后14天内，从App中对所有的收据进行拍照;</li>
                <li>您所有已验证的收据将被合并到一张由Airvat签发的退税单中;</li>
                <li>在前往机场前打印您的Airvat退税单！</li>
                <li>请按照App中关于从哪儿让您的Airvat退税单被机场海关批准的说明进行操作;</li>
                <li>在您离开后2-8周内收到退款。</li>
              </ul>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                谁可以免税购物?
              </h3>
            </div>
            <div className="answer">
              <ul>
                <li>非欧盟居民;</li>
                <li>居住在欧盟以外12个月或以上的欧盟公民（注：您需要提供非欧盟居民身份的证明，如外国签证、居留证或职业证明）;</li>
                <li>任何在欧盟学习或工作者，在永久回国前的最后3个月内所进行的购物都可以获得退税（注：您需要向海关证明：1. 您至少有12个月没有返回欧盟，2. 证明您的工作或学习已结束）.</li>
              </ul>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                哪些商品可以退税?
              </h3>
            </div>
            <div className="answer">
              <ul>
                <li>仅在实体零售商店购买的商品（即非网购）;</li>
                <li>所购商品必须归个人使用，并在购买后的3个月内放在您的个人行李中带离欧盟;</li>
                <li>您的退税购物必须未使用，仍为原包装，并且在离开欧盟时可供海关查验.</li>
              </ul>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                哪些商品不能用Airavat进行退税?
              </h3>
            </div>
            <div className="answer">
              <ul>
                <li>网上购物;</li>
                <li>已收到店内退税单的商品;</li>
                <li>服务（例如交通、酒店住宿、娱乐门票或餐厅食物）;</li>
                <li>童装;</li>
                <li>书籍;</li>
                <li>基本食品，例如咖啡、茶、蜂蜜等（即在超市购买的大多数食品）;</li>
                <li>直接快递或邮寄至您的国家的商品;</li>
                <li>任何您不能放在行李里带回家并需要在机场出示给海关进行查验的物品.</li>
              </ul>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                哪些收据可以使用Airvat退税?
              </h3>
            </div>
            <div className="answer">
              <p>
                每张收据必须低于250英镑并包含以下信息:
              </p>
              <ol>
                <li>增值税 (VAT) 税率或金额;</li>
                <li>零售商名称和地址;</li>
                <li>零售商的增值税 (VAT) 登记号;</li>
                <li>收据日期和编号;</li>
                <li>商品说明、数量和价格.</li>
              </ol>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                那购买的商品超过250英镑呢?
              </h3>
            </div>
            <div className="answer">
              <ul>
                <li>每张收据（即非每件商品）都适用250英镑的限额。为避免超过250英镑，购买商品时您可以单独付款.</li>
                <li>
                  如果您要购买价值超过250英镑的单件商品，请让店员开具一张寄给Airvat的增值税 (VAT) 商业发票，地址为: <br />
                  <strong>AIRVAT ltd <br />
                  20-22 Wenlock Road, <br />
                  London, N1 7GU, UK <br />
                  增值税税号 312 0922 50 <br /></strong>
                </li>
              </ul>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                我已收到店内退税单
              </h3>
            </div>
            <div className="answer">
              <p>
                很遗憾，如果购物时已经在店内开出了退税单，则您将无法使用Airvat进行任何购买。但是，您可以退回店内增值税 (VAT) 原退税单，并要求店员向您开具普通收据。然后您就可以使用Airvat App处理收据了. 
              </p>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                我在机场需要做什么?
              </h3>
            </div>
            <div className="answer">
              <ul>
                <li>在Airvat App中选择您的出发机场，然后按照说明找到海关柜台;</li>
                <li>将尚未使用的商品放在原包装中进行查验;</li>
                <li>出发前，让海关对您打印好的Airvat退税单进行盖章.</li>
              </ul>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                我需要出示什么才能在机场让海关盖章?
              </h3>
            </div>
            <div className="answer">
              <ul>
                <li>打印好的Airvat退税单;</li>
                <li>机票或登机牌;</li>
                <li>有效护照;</li>
                <li>存放在原包装中尚未使用的已购物品.</li>
              </ul>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                我需要去机场的什么地方? 
              </h3>
            </div>
            <div className="answer">
              <ul>
                <li>机场安检前后通常都有海关柜台;</li>
                <li>如果您有想要办理登机手续的物品，请前往安检前的海关柜台，并在托运行李之前使退税单被批准;</li>
                <li>如果您有贵重物品（价值超过1000英镑），或各种贵重物品，如珠宝、手表、太阳镜、便携式电子产品等，请在安检后前往海关柜台。您需要将物品放在行李箱中随身携带;</li>
                <li>提示：安检后在海关柜台的等待时间通常不超过15分钟。如果您没有为购买的退税商品办理登记托运手续，那么在安检后退税单验证流程会更快.</li>
              </ul>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                我的退税有保证吗?
              </h3>
            </div>
            <div className="answer">
              <p>
                是的，只要您在离开欧盟前在离境机场拿到海关盖章的退税单。在App中选择您的出发机场，以获取在机场时应该去哪里的说明.
              </p>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                家商店通过电子邮件给我发了电子收据
              </h3>
            </div>
            <div className="answer">
              <p>
                将您的电子收据转发给 <a href="emailto:info@airvat.com">info@airvat.com</a>
              </p>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                在回国之前，我要去往另一个欧盟国家
              </h3>
            </div>
            <div className="answer">
              <p>
                如果英国不是您离开欧盟的最后一个出发地，则请在欧盟最后一个出发机场取得海关批准，并将已盖章的退税单原件邮寄给我们，地址: <br />
                <strong>AIRVAT ltd <br />
                20-22 Wenlock Road, <br />
                London, N1 7GU, <br />
                United Kingdom</strong>
              </p>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                我在离开欧盟之前要转一趟机
              </h3>
            </div>
            <div className="answer">
              <p>
                如果您的转机航班在您离开英国后24小时内离开欧盟，那么英国海关是会在您的退税单上盖章的. 
              </p>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                我可以在哪些国家使用AIRVAT?
              </h3>
            </div>
            <div className="answer">
              <p>只有在英国购买商品时可以，但是您在欧盟旅行期间可以前往和离开任何其他欧盟国家.</p>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                AIRVAT收费吗?
              </h3>
            </div>
            <div className="answer">
              <p>
                是的，我们的费用是退款金额的20％。您的退税单将会列出所收取的准确数额的管理费用。您也可以使用我们App中的计算器来计算费用。我们的费用通常要比从您购买商品的商店获得退款时少得多.
              </p>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                我什么时候能收到退款?
              </h3>
            </div>
            <div className="answer">
              <p>
                通常在离开后2-8周内，具体取决于您离境时的机场.
              </p>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                我可以在哪里打印退税单?
              </h3>
            </div>
            <div className="answer">
              <p>
                在您所住的酒店前台询问，也可以去网络咖啡屋，还可以去最近的Ryman文具店，或者是Snappy Snaps印刷专家.
              </p>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                什么是增值税 (VAT)?
              </h3>
            </div>
            <div className="answer">
              <p>
                增值税 (VAT) 是已包含在购买价格中的销售税。该税由英国政府按净价的20％和商品总价的16.67％收取。非欧盟居民有权对旅行结束后从欧盟带回家的商品申请退税. 
              </p>
            </div>
          </div>
          <div className="accordion js-accordion">
            <div className="question" onClick={handleClick}>
              <h3>
                还有其他问题吗?
              </h3>
            </div>
            <div className="answer">
              <p>
                请发电子邮件至 <a href="emailto:info@airvat.com">info@airvat.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default FaqPage